<template>
    <div class="tabs-container" :style="TabsStyle">
        <div v-for="(item, index) in data" 
            :key="index"
            :class="{active: checked === index}"
            @click="select(index)">
            {{ item }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: Array,
        TabsStyle: Object,
        checked: Number
    },
    data () {
        return {
            active: 0
        }
    },
    methods: {
        select: function (index) {
            this.$emit('changed', index);
        }
    }
}
</script>

<style lang="less" scoped>
.tabs-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    div {
        height: 64rem;
        border-top: 2px solid #FFFFFF;
        
        font-size: 18rem;
        font-weight: 400;
        color: #999999;
        margin: 0 10rem;
        cursor: pointer;
    }

    .active {
        border-top: 2px solid #0D94FF;
        box-sizing: border-box;
        color: #0D94FF;
    
        font-size: 18rem;
        font-weight: bold;
    }
}
</style>